// extracted by mini-css-extract-plugin
module.exports = {"link":"_3FDsHZ","imageTitle":"_2dnv2v","image":"dyLOKH","text":"_1QHKpe"};